import { takeLatest, call, select, put } from 'redux-saga/effects';
import safeSaga from '../safeSaga';
import { ADD_ITEM_TO_FAVOURITES } from '../../actions/actionTypes';
import { addToFavourites } from '../../api/favouritesApi';
import {
  favouritesSelector,
} from '../../selectors';
import { completeSaveToFavourites } from '../../actions/favoriteAction';

function* saveToFavourites() {
  try {
    const { listId, listName, omsId } = yield select(favouritesSelector);
    const memberId = window.THDCustomer?.default?.svocID || '';
    if (!memberId) return;
    const payload = {
      memberId, listId, listName, omsId,
    };
    const resp = yield call(addToFavourites, payload);
    const { listResponse: { status } } = resp;
    if (status === 'SUCCESS') { yield put(completeSaveToFavourites()); }
  } catch (err) {
    throw err;
  }
}

export default function* saveToFavouritesSaga() {
  yield takeLatest(ADD_ITEM_TO_FAVOURITES, safeSaga(saveToFavourites));
}
